module.exports = __webpack_public_path__ + "img/stacked_line_chart.d856c45a.svg";